import '@fontsource-variable/montserrat';
import $ from "jquery";


import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HandheldMenu from "./components/handheld-menu";
import DropdownMenu from "./components/dropdown-menu";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";

import DeviceManager from "./utils/device-manager";
import { Lightbox } from './components/lightbox';
import { AccordionDef } from './components/accordion';
import { addDotBtnsAndClickHandlers } from './components/emblaCarouselDotButton';
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import { addPrevNextBtnsClickHandlers } from './components/emblacarouselarrowbutton';
import ClassNames from 'embla-carousel-class-names';

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $("html");

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass("touch");

      if (DeviceManager.isIos()) {
        $html.addClass("ios");
      }
    } else {
      $html.addClass("no-touch");
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass("ie11");
    } else if (DeviceManager.isEdge()) {
      $html.addClass("edge");
    }
  };

  const instanciateComponents = () => {
    // General components
    const langSelector = new LangSelector($(".language-selector"));
    const siteHeader = new SiteHeader($(".site-header"), 20);

    // Home slider component


    // Newsletter form component
    const $newsletterFormElements = $(
      ".footer-block.footer-block--newsletter-style"
    );
    if ($newsletterFormElements.length) {
      $newsletterFormElements.each(function (index, el) {
        const newsletterForm = new NewsletterForm(el);
      });
    }

    // Scroll in view component
    const $scrollInViewElements = $(".scroll-in-view");
    if ($scrollInViewElements.length) {
      const scrollInView = new ScrollInView($scrollInViewElements);
    }
  };

  bootstrapApp();
  instanciateComponents();
});

const wpmlLink = document.querySelector(".js-wpml-ls-item-toggle");

if (wpmlLink) {
wpmlLink.removeEventListener('click', function(){}, false);

wpmlLink.addEventListener('click', function(e) {
  e.preventDefault();
  const parentLi = wpmlLink.closest('.wpml-ls-item');
  parentLi.classList.toggle('wpml-ls-item-opened');
}, false);
}

const galleryLightboxSections = document.querySelectorAll(".section-gallery")

if (galleryLightboxSections) {
    galleryLightboxSections.forEach((section) => {
        const galleryContainer = section.querySelector('.section-gallery__images')

        if (galleryContainer) {
            Lightbox.init(galleryContainer)
        }

    })
}

const accordion = document.querySelectorAll('.accordion')

if (accordion) {
    accordion.forEach((item) => {
        new AccordionDef(item)
    })
}

const voyageSliderNode = document.querySelector('.home-voyage-slider')

if (voyageSliderNode) {
    const OPTIONS = { align: 'start' }

    const viewportNode = voyageSliderNode.querySelector('.embla__viewport')
    const dotsNode = voyageSliderNode.querySelector('.embla__dots')
    const prevBtnNode = voyageSliderNode.querySelector('.embla__button--prev')
    const nextBtnNode = voyageSliderNode.querySelector('.embla__button--next')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()])

    const onNavButtonClick = (emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay

        if (!autoplay) return

        const resetOrStop = autoplay.options.stopOnInteraction == false ? autoplay.reset : autoplay.stop

        resetOrStop()
    }

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode,
        onNavButtonClick
    )

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
        onNavButtonClick
    )

    emblaApi.on('destroy', removeDotBtnsAndClickHandlers)
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
}

const homeNewSliderNode = document.querySelector('.news-list.embla')

if (homeNewSliderNode) {
    const OPTIONS = {
        align: 'start',
        breakpoints: {
            '(min-width: 1440px)' : {
                active: false
            }
        }
    }

    const viewportNode = homeNewSliderNode.querySelector('.embla__viewport')
    const dotsNode = homeNewSliderNode.querySelector('.embla__dots')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay(), ClassNames()])

    const onNavButtonClick = (emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay

        if (!autoplay) return

        const resetOrStop = autoplay.options.stopOnInteraction == false ? autoplay.reset : autoplay.stop

        resetOrStop()
    }

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode,
        onNavButtonClick
    )

    emblaApi.on('destroy', removeDotBtnsAndClickHandlers)

    if (window.innerWidth >= 1440) {
        const newsListItem = homeNewSliderNode.querySelectorAll('.news-list__item')

        newsListItem.forEach((item) => {
            item.addEventListener('click', () => {
                newsListItem.forEach((el) => {
                    el.classList.remove('active')
                })

                item.classList.toggle('active')
            })
        })
    }

}

const testimoniesList = document.querySelector('.testimonies-list')

if (testimoniesList) {
    const OPTIONS = { align: 'start' }

    const viewportNode = testimoniesList.querySelector('.embla__viewport')
    const dotsNode = testimoniesList.querySelector('.embla__dots')
    const prevBtnNode = testimoniesList.querySelector('.embla__button--prev')
    const nextBtnNode = testimoniesList.querySelector('.embla__button--next')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()])

    const onNavButtonClick = (emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay

        if (!autoplay) return

        const resetOrStop = autoplay.options.stopOnInteraction == false ? autoplay.reset : autoplay.stop

        resetOrStop()
    }

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode,
        onNavButtonClick
    )

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
        onNavButtonClick
    )

    emblaApi.on('destroy', removeDotBtnsAndClickHandlers)
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
}

const vehiculeItems = document.querySelectorAll('.vehicule-item')

if (vehiculeItems) {
    for (const item of vehiculeItems) {
        const text = item.querySelector('span').getBoundingClientRect()
        const vehiculeImage = item.querySelector('.vehicule__image-container')
        const vehiculeImageRect = vehiculeImage.getBoundingClientRect()

        vehiculeImage.style.right = 'unset';
        vehiculeImage.style.left = `calc(${text.width}px + 10px + ${vehiculeImageRect.width}px / 2)`
    }
}
